import $ from "jquery";
import { u_ } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";

vuwer.get("pageMain").setProp({
	async onReady($self) {
		const promiseList = [];
		
		const $groupBox = $self.find(".group-box").each((i, box) => {
			// add thumbnail img.
			$(box).find("a[data-thumb]").each((j, elm) => {
				const $elm = $(elm);
				const ext = $elm.attr("data-thumb");
				!!ext && promiseList.push( new Promise(resolve => {
					const { dirname, filename } = u_.pathInfo(elm.href);
					const $thumbnail = $("<img/>").addClass("thumbnail").attr({
						src: `${dirname}/${filename}.${ext}`,
						alt: ""
					}).on("load error", e => resolve()).prependTo($elm);
					
					!!$thumbnail.height() && resolve();
				}) );
			});
		});
		
		this.setProp({ $groupBox });
		
		!!promiseList.length && await Promise.all(promiseList);
	}
});
